module.exports = __webpack_public_path__ + "img/icon.caa452d7.jpg";